import {
  WALLET_TRANSACTION_HISTORY,
  WALLET_TRANSACTION_HISTORY_SUCCESS,
  CLEAN_WALLET_TRANSACTION_HISTORY,
  KYC_DONE,
  KYC_DONE_SUCCESS,
  GET_EXPENSE_IMAGE,
  GET_EXPENSE_IMAGE_SUCCESS,
  DELETE_EXPENSE,
  DELETE_EXPENSE_SUCCESS,
  EDIT_EXPENSE_SUCCESS,
  EDIT_EXPENSE,
  QR_CODE_SUCCESS,
  QR_CODE,
  CHANGE_DRIVER_LIMIT,
  CHANGE_DRIVER_LIMIT_SUCCESS,
  MODIFY_LIMIT,
  MODIFY_LIMIT_SUCCESS,
  VERIFY_OTP_FOR_LIMIT,
  VERIFY_OTP_FOR_LIMIT_SUCCESS,
  REGISTER_YESBANK,
  REGISTOR_NEW_CUSTOMER,
  REGISTOR_NEW_CUSTOMER_SUCCESS,
  REGISTOR_NEW_CUSTOMER_VERIFY_OTP,
REGISTOR_NEW_CUSTOMER_VERIFY_OTP_SUCCESS,
CUSTOMER_MIN_KYC,
CUSTOMER_MIN_KYC_SUCCESS,
REPLACE_CARD,
REPLACE_CARD_SUCCESS,
BLOCK_CARD,
BLOCK_CARD_SUCCESS,
BULK_ADD_DRIVER_COMPLETE_UPLOAD,
BULK_ADD_DRIVER_COMPLETE_UPLOAD_SUCCESS,
  GET_TRANSACTION_DETAILS,
  GET_TRANSACTION_DETAILS_SUCCESS,
  GET_TRANSACTION_SLIP_PDF,
  GET_TRANSACTION_SLIP_PDF_SUCCESS,
  GET_CARD_TRANSACTION_DETAILS,
  GET_CARD_TRANSACTION_DETAILS_SUCCESS,
  GET_FASTAG_TRANSACTION_DETAILS,
  GET_FASTAG_TRANSACTION_DETAILS_SUCCESS,
  GET_FASTAG_WALLET_TRANSACTION_DETAILS,
  GET_FASTAG_WALLET_TRANSACTION_DETAILS_SUCCESS,
  CLEAR_TRANSACTION_DETAILS,
  GET_CARD_TRANSACTION_SLIP_PDF,
  GET_CARD_TRANSACTION_SLIP_PDF_SUCCESS,
  GET_FASTAG_TRANSACTION_SLIP_PDF,
  GET_FASTAG_TRANSACTION_SLIP_PDF_SUCCESS,
  GET_FASTAG_WALLET_TRANSACTION_SLIP_PDF,
  GET_FASTAG_WALLET_TRANSACTION_SLIP_PDF_SUCCESS,  
  GET_CARD_WALLET_BALANCE,
  GET_CARD_WALLET_BALANCE_SUCCESS,
  GET_CARD_WALLET_HISTORY,
  GET_CARD_WALLET_HISTORY_SUCCESS,
  CLEAR_CARD_WALLET_HISTORY,
  CREATE_CARD_WALLET,
  CREATE_CARD_WALLET_SUCCESS,
  GENERATE_CARD_WALLET_STATEMENT,
  GENERATE_CARD_WALLET_STATEMENT_SUCCESS,
  GET_CARD_WALLET_TXNSLIP,
  GET_CARD_WALLET_TXNSLIP_SUCCESS,
  DOWNLOAD_CARD_WALLET_TXNSLIP_PDF,
  DOWNLOAD_CARD_WALLET_TXNSLIP_PDF_SUCCESS,
} from "../storeTypes";

const INIT_STATE = {
  loader: false,
  walletTransactionHistory: [],
  walletTransactionHistoryList: [],
  kycDone: 0,
  imageUrlObj: {},
  editExpense:{},
  qrCode:"",
  transactionSlip: {},
  cardWallet: {},
  cardWalletHistoryList: [],
  cardWalletHistoryCount: 0,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case QR_CODE: {
      console.log("step-b");
      return {
        ...state,
        loader: true,
      };
    }
    case QR_CODE_SUCCESS: {
      console.log("successssssss", action.payload);
      return {
        ...state,
        loader: false,
        qrCode:action?.payload?.qrCode,
      };
    }
    case WALLET_TRANSACTION_HISTORY: {
      console.log("step-b");
      return {
        ...state,
        loader: true,
      };
    }
    case WALLET_TRANSACTION_HISTORY_SUCCESS: {
      console.log("successssssss", action.payload);
      return {
        ...state,
        loader: false,
        walletTransactionHistory: action.payload,
        walletTransactionHistoryList: [
          ...state.walletTransactionHistoryList,
          ...action?.payload?.instrument_statement?.records,
        ],
      };
    }
    case CLEAN_WALLET_TRANSACTION_HISTORY: {
      console.log("running clean");
      return {
        ...state,
        loader: false,
        walletTransactionHistory: [],
        walletTransactionHistoryList: [],
      };
    }
    case KYC_DONE: {
      return {
        ...state,
        loader: true,
      };
    }
    case KYC_DONE_SUCCESS: {
      return {
        ...state,
        loader: false,
        kycDone: action.payload,
      };
    }
    case GET_EXPENSE_IMAGE: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_EXPENSE_IMAGE_SUCCESS: {
      return {
        ...state,
        loader: false,
        imageUrlObj: action.payload,
      };
    }
    case DELETE_EXPENSE: {
      return {
        ...state,
        loader: true,
      };
    }
    case DELETE_EXPENSE_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    case EDIT_EXPENSE:{
      return {
        ...state,
        loader: true,
      };
    }
    case EDIT_EXPENSE_SUCCESS: {
      return {
        ...state,
        loader: false,
        editExpense: action.payload,
      };
    }

    case CHANGE_DRIVER_LIMIT:{
      return {
        ...state,
        loader: true,
      };
    }
    case CHANGE_DRIVER_LIMIT_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    case MODIFY_LIMIT: {
      return {
        ...state,
        loader: true,
      };
    }
    case MODIFY_LIMIT_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    case VERIFY_OTP_FOR_LIMIT: {
      return {
        ...state,
        loader: true,
      };
    }
    case VERIFY_OTP_FOR_LIMIT_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case REGISTOR_NEW_CUSTOMER: {
      return {
        ...state,
        loader: true,
      };
    }
    case REGISTOR_NEW_CUSTOMER_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case REGISTOR_NEW_CUSTOMER_VERIFY_OTP: {
      return {
        ...state,
        loader: true,
      };
    }
    case REGISTOR_NEW_CUSTOMER_VERIFY_OTP_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case CUSTOMER_MIN_KYC: {
      return {
        ...state,
        loader: true,
      };
    }
    case CUSTOMER_MIN_KYC_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case REPLACE_CARD: {
      return {
        ...state,
        loader: true,
      };
    }
    case REPLACE_CARD_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case BLOCK_CARD: {
      return {
        ...state,
        loader: true,
      };
    }
    case BLOCK_CARD_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    
    case BULK_ADD_DRIVER_COMPLETE_UPLOAD: {
      return {
        ...state,
        loader: true,
      };
    }
    case BULK_ADD_DRIVER_COMPLETE_UPLOAD_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case GET_TRANSACTION_DETAILS: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_TRANSACTION_DETAILS_SUCCESS: {
      return {
        ...state,
        transactionSlip: action?.payload,
        loader: false,
      };
    }
    case GET_CARD_TRANSACTION_DETAILS: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_CARD_TRANSACTION_DETAILS_SUCCESS: {
      return {
        ...state,
        transactionSlip: action?.payload,
        loader: false,
      };
    }
    case GET_FASTAG_TRANSACTION_DETAILS: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_FASTAG_TRANSACTION_DETAILS_SUCCESS: {
      return {
        ...state,
        transactionSlip: action?.payload,
        loader: false,
      };
    }
    case GET_FASTAG_WALLET_TRANSACTION_DETAILS: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_FASTAG_WALLET_TRANSACTION_DETAILS_SUCCESS: {
      return {
        ...state,
        transactionSlip: action?.payload,
        loader: false,
      };
    }
    case CLEAR_TRANSACTION_DETAILS: {
      return {
        ...state,
        transactionSlip: {},
        loader: false,
      };
    }
    case GET_TRANSACTION_SLIP_PDF: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_TRANSACTION_SLIP_PDF_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    case GET_CARD_TRANSACTION_SLIP_PDF: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_CARD_TRANSACTION_SLIP_PDF_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    case GET_FASTAG_TRANSACTION_SLIP_PDF: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_FASTAG_TRANSACTION_SLIP_PDF_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    case GET_FASTAG_WALLET_TRANSACTION_SLIP_PDF: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_FASTAG_WALLET_TRANSACTION_SLIP_PDF_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case GET_CARD_WALLET_BALANCE: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_CARD_WALLET_BALANCE_SUCCESS: {
      console.log("GET_CARD_WALLET_BALANCE_SUCCESS",action);
      return {
        ...state,
        loader: false,
        cardWallet: action?.payload,
      };
    }

    case GET_CARD_WALLET_HISTORY: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_CARD_WALLET_HISTORY_SUCCESS: {
      return {
        ...state,
        loader: false,
        cardWalletHistoryList: action?.payload?.rows,
        cardWalletHistoryCount: action?.payload?.count,
      };
    }
    case CLEAR_CARD_WALLET_HISTORY: {
      return {
        ...state,
        loader: false,
        cardWalletHistoryList: [],
        cardWalletHistoryCount: 0,
      };
    }

    case CREATE_CARD_WALLET: {
      return {
        ...state,
        loader: true,
      };
    }
    case CREATE_CARD_WALLET_SUCCESS: {
      return {
        ...state,
        loader: false,
        cardWallet: action?.payload,
      };
    }

    case GENERATE_CARD_WALLET_STATEMENT: {
      return {
        ...state,
        loader: true,
      };
    }
    case GENERATE_CARD_WALLET_STATEMENT_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case GET_CARD_WALLET_TXNSLIP: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_CARD_WALLET_TXNSLIP_SUCCESS: {
      return {
        ...state,
        transactionSlip: action?.payload,
        loader: false,
      };
    }
    case DOWNLOAD_CARD_WALLET_TXNSLIP_PDF: {
      return {
        ...state,
        loader: true,
      };
    }
    case DOWNLOAD_CARD_WALLET_TXNSLIP_PDF_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }
    default: {
      return state;
    }
  }
};
